import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosPost } from '../api/axios';

export interface RedeemPartnerCodePayload {
  userId: number;
  partnerCode: string;
}

const createRedeemPartnerCodeRequest = async (input: RedeemPartnerCodePayload): Promise<any> => {
  const { userId, partnerCode } = input;
  return await axiosPost(`/partners/redeem_partner_code?user_id=${userId}&partner_code=${partnerCode}`, {}, 'v2').then(
    (response: { data: any }) => response.data,
  );
};

export const useCreateRedeemPartnerCode = () => {
  const queryClient = useQueryClient();
  return useMutation((input: RedeemPartnerCodePayload) => createRedeemPartnerCodeRequest(input), {
    onSuccess: () => {
      queryClient.invalidateQueries(['Users']);
    },
    onError: () => {
      queryClient.invalidateQueries(['Users']);
    },
  });
};
